
import { defineComponent } from 'vue';
import { UserOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import { CHANGE_CURRENT_SHOP } from '@/store/modules/user/actions';

export default defineComponent({
  name: 'ShopNameNow',
  props: {
    shop_list: {
      type: Array,
      default: () => [],
    },
    current_shop: {
      type: Object,
      default: () => {},
    },
    menu: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    const select_shop = (obj: any) => {
      // ls.set(STORAGE_CURRENT_ORG_KEY, obj);
      store.dispatch(`user/${CHANGE_CURRENT_SHOP}`, obj).then(() => {
        router.push({
          path: '/workplace',
          query: { init: '/workplace' },
        });
      });
    };

    return {
      t,
      select_shop,
    };
  },
  components: {
    UserOutlined,
  },
});
